import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiPhone } = FiIcons;

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#3466ad] to-[#2a5291] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center text-white"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ihr Bauprojekt beginnt hier.
          </h2>
          <p className="text-xl md:text-2xl mb-12 max-w-4xl mx-auto leading-relaxed opacity-90">
            Lassen Sie uns gemeinsam Ihre Baupläne verwirklichen. Kontaktieren Sie uns für eine unverbindliche Beratung und ein individuelles Angebot.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Link 
              to="/kontakt" 
              className="inline-flex items-center space-x-2 bg-white text-[#3466ad] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <span>Jetzt Kontakt aufnehmen</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </Link>
            <a 
              href="tel:+4924528607019" 
              className="inline-flex items-center space-x-2 border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-[#3466ad] transition-all duration-200"
            >
              <SafeIcon icon={FiPhone} className="w-5 h-5" />
              <span>02452 860 70 19</span>
            </a>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="text-3xl font-bold mb-2">24h</div>
              <div className="opacity-90">Rückmeldung garantiert</div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <div className="text-3xl font-bold mb-2">Kostenlos</div>
              <div className="opacity-90">Erstberatung & Angebot</div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <div className="text-3xl font-bold mb-2">Vor Ort</div>
              <div className="opacity-90">Persönliche Beratung</div>
            </motion.div>
          </div>
        </motion.div>
      </div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
      </div>
    </section>
  );
};

export default CTASection;